/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplierBatchLineAllocationDto
 */
export interface SupplierBatchLineAllocationDto {
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineAllocationDto
     */
    orderItemId: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineAllocationDto
     */
    orderId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchLineAllocationDto
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchLineAllocationDto
     */
    branchId: number | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchLineAllocationDto
     */
    branchName: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchLineAllocationDto
     */
    retailerPhone: string | null;
    /**
     * Original qty requested by retailer for this orderItem
     * @type {number}
     * @memberof SupplierBatchLineAllocationDto
     */
    requestedQuantity: number;
    /**
     * Admin-allocated qty. Null until allocated.
     * @type {number}
     * @memberof SupplierBatchLineAllocationDto
     */
    allocatedQuantity: number | null;
}

/**
 * Check if a given object implements the SupplierBatchLineAllocationDto interface.
 */
export function instanceOfSupplierBatchLineAllocationDto(value: object): value is SupplierBatchLineAllocationDto {
    if (!('orderItemId' in value) || value['orderItemId'] === undefined) return false;
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    if (!('orderNumber' in value) || value['orderNumber'] === undefined) return false;
    if (!('branchId' in value) || value['branchId'] === undefined) return false;
    if (!('branchName' in value) || value['branchName'] === undefined) return false;
    if (!('retailerPhone' in value) || value['retailerPhone'] === undefined) return false;
    if (!('requestedQuantity' in value) || value['requestedQuantity'] === undefined) return false;
    if (!('allocatedQuantity' in value) || value['allocatedQuantity'] === undefined) return false;
    return true;
}

export function SupplierBatchLineAllocationDtoFromJSON(json: any): SupplierBatchLineAllocationDto {
    return SupplierBatchLineAllocationDtoFromJSONTyped(json, false);
}

export function SupplierBatchLineAllocationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierBatchLineAllocationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'orderItemId': json['orderItemId'],
        'orderId': json['orderId'],
        'orderNumber': json['orderNumber'],
        'branchId': json['branchId'],
        'branchName': json['branchName'],
        'retailerPhone': json['retailerPhone'],
        'requestedQuantity': json['requestedQuantity'],
        'allocatedQuantity': json['allocatedQuantity'],
    };
}

export function SupplierBatchLineAllocationDtoToJSON(value?: SupplierBatchLineAllocationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orderItemId': value['orderItemId'],
        'orderId': value['orderId'],
        'orderNumber': value['orderNumber'],
        'branchId': value['branchId'],
        'branchName': value['branchName'],
        'retailerPhone': value['retailerPhone'],
        'requestedQuantity': value['requestedQuantity'],
        'allocatedQuantity': value['allocatedQuantity'],
    };
}

